class Model {
  constructor (data) {
    this.setData(data)
  }

  get schema () {
    return []
  }

  get formatters () {
    return {}
  }

  setData (data) {
    const modelData = data || {}

    this.schema.forEach(attribute => {
      const attributeFormatter = this.formatters[attribute]
      let attributeValue = modelData[attribute]

      if (attributeFormatter !== undefined && attributeValue != null) {
        attributeValue = attributeFormatter(modelData[attribute])
      }

      this[attribute] = attributeValue
    })
  }
}

export default Model
